import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_3eQw6ITzx",
  client_id: "7t5d70l9eh5t6e1nv8b8ebk50o",
  redirect_uri: "https://mybilladvocate.com",
  response_type: "code",
  scope: "phone openid email",
  post_logout_redirect_uri: "https://mybilladvocate.com",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
